import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {pageMargin} from "../../../utils/styles";

const useStyles = makeStyles(theme => ({
    root: {
        ...pageMargin(theme)
    }
}));

export default function PageWrapper(props) {
    const {
        children
    } = props;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {children}
        </div>
    );
};